/* unplugin-vue-components disabled */import script from "./HomeViews.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeViews.vue?vue&type=script&setup=true&lang=ts"

import "./HomeViews.vue?vue&type=style&index=0&id=36aeed4e&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36aeed4e"]])

export default __exports__